import React, { useMemo, useState } from 'react';
import { shallowEqual, useSelector } from 'umi';
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import { PERIODTIMEOBJ } from '@/pages/dashboard/_config/constant';
import { Iprops, TApiParamsBase } from '../../_type';

export default function IngameDlpBreakdownService(props: Iprops) {
  const { style, className, config, children , ...resetProps } = props || {};
  const { api, refreshKey='', interval, metric = [], byType, topMetric, extMetricMap, serviceParams: restApiConfig} = config || {};
  const { gameCode } = useSelector((state: any) => ({
    gameCode: state?.dashboard?.currentGame?.game_code
  }), shallowEqual);
  const [sortTopMetric, setSortTopMetric] = useState(topMetric);

  const data = useMemo(() => ({
    gameCode,
    sortTopMetric
  }), [gameCode, sortTopMetric]);

  // 格式化数据
  const  transformDataList = (dataList: any[]) => {
    const result = {};
    dataList?.forEach((item: { [x: string]: any; }) => {
      for (const key in item) {
        result[key] = Array.isArray(item[key]) ? item[key] : {};
      }
    });
    return result;
  };

  const formatData = (data: any) => {
    const dwmList = data?.dwm_list || {};
    // metric 有且只能有两个
    const dataList = metric?.map((item, index)=>({
      [item]: dwmList?.map((meitricsItem: { metrics: { [x: string]: any; }; name: any; full_name: any; value: string; }) =>{
        const metricDataItem = meitricsItem?.metrics?.[item];
        const metricContrastDataItem = meitricsItem?.metrics?.[extMetricMap?.[item]];
        // 兼容FTC组件进行数据处理
        return ({
          ...(metricDataItem || {}),
          name: meitricsItem?.name || '',
          full_name: meitricsItem?.full_name || '',
          // 对比的值和百分比
          value_ext1: metricContrastDataItem?.value,
          share_off_all_ext1: metricContrastDataItem?.share_off_all,
        });
      })
    })); 
    const dataObj = transformDataList(dataList);
    return {
      ...(dataObj || {}),
      by_type: byType
    };
  };
  
  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        dataKey={'breakDownData'}
        refreshKey={refreshKey}
        interval={interval}
        formatData={formatData}
        beforeRequest={(data) => {
          const { filterVal, gameCode, sortTopMetric } = data;
          const { rangeTime, timeType, ...filters } = filterVal || {};
          // 传参兜底筛选器参数
          
          const params: TApiParamsBase = {
            game_code: gameCode,
            filters: formatFilterValues(filters),
            start_time: rangeTime[0],
            end_time: rangeTime[1],
            period: PERIODTIMEOBJ[timeType],
            metrics: metric,
            accumulation: {
              [byType]: true
            },
            top_metric: sortTopMetric,
            ...restApiConfig
          };
          return params;
        }}
        trackData={['gameCode', 'sortTopMetric']}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            ...(resetProps || {}),
            extMetricMap,
            setSortTopMetric
          }
        ))}
      </Service>
    </div>
  );
};